﻿﻿import { ITicketGroupUser } from './ticket-group-user';

export interface ITicketGroupRequest {
    id: number;
    name: string;
    isNkr: boolean;
    category: number;
    users: ITicketGroupUser[];
}
